import { useQuery } from '@tanstack/react-query';
import * as search from '@/api/search.api';

export function useSearch(q: string, enabled: boolean) {
  return useQuery({
    queryKey: ['search', q],
    queryFn: () => search.search(q),
    enabled,
    staleTime: 60_000,
  });
}
